<app-breadcrumb></app-breadcrumb>

<form [formGroup]="formGroup">
  <p-panel header="功能標題 (查詢結果 Inline Edit)"
    [toggleable]="true" [collapsed]="panelCollapsed"
    expandIcon="pi pi-search" collapseIcon="pi pi-search-minus">
    <div class="card" #contentElement pBPaaSFocusTrap>
      <div class="grid p-fluid">
        <div class="col-12 md:col-3 lg:col-3">
          <label>文字輸入</label>
          <input type="text" pInputText
            formControlName="input" [id]="parseToId('input')">
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <label>選擇日期</label>
          <p-calendar [showIcon]="true" appendTo="body"
            formControlName="calendar" dateFormat="yy/mm/dd" dataType="string"
            placeholder="yyyy/mm/dd"
            [showOnFocus]="false"
            [inputId]="parseToId('calendar')">
          </p-calendar>
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <label class="bpaas-required">下拉選單 (固定選項)</label>
          <p-dropdown *ngIf="langChangeVisible"
            [options]="exampleOptions"
            placeholder="{{ 'option.please-select' | translate }}" [showClear]="true"
            [autoDisplayFirst]="false"
            formControlName="dropdown" [inputId]="parseToId('dropdown')"
            [ngClass]="{'ng-dirty': formControlInvalid('dropdown')}">
          </p-dropdown>
          <div *ngIf="formControlInvalid('dropdown')">
            <small class="p-error"
              *ngIf="formControl('dropdown').errors?.['required']">
              {{ 'message.validation.required' | translate }}
            </small>
          </div>
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <label>自動完成</label>
          <p-autoComplete *ngIf="langChangeVisible"
            [suggestions]="exampleDataSuggestions"
            [forceSelection]="true"
            [minLength]="2" [delay]="300" [showClear]="true"
            [showEmptyMessage]="true" emptyMessage="{{ 'table.no-records-found' | translate }}"
            (completeMethod)="searchExampleDataSuggestions($event)"
            (onClear)="autoCompleteCleared('autoCompleteCode')"
            (onFocus)="autoCompleteFocus($event)"
            (onBlur)="autoCompleteBlur($event)"
            (onKeyUp)="autoCompleteKeyUp($event)"
            (onSelect)="autoCompleteCompleted('autoCompleteCode')"
            formControlName="autoCompleteCode" [inputId]="parseToId('autoCompleteCode')"
            field="{{ 'exampleDataName' | translateFieldName: 'exampleDataName' }}">
            <ng-template let-exampleData pTemplate="item">
              {{ exampleData.exampleDataCode }} {{ exampleData.exampleDataName | translateDataValue: exampleData : 'exampleDataName' }}
            </ng-template>
          </p-autoComplete>
        </div>
      </div>
    </div>
    <div class="grid p-fluid justify-content-end bpaas-button-row">
      <div class="col-12 md:col-3 lg:col-2">
        <button type="button" pButton label="{{ 'button.reset' | translate }}" class="p-button-outlined mr-2" (click)="searchReset()" [id]="parseToId('btnReset')"></button>
      </div>
      <div class="col-12 md:col-3 lg:col-2">
        <button type="button" pButton label="{{ 'button.query' | translate }}" (click)="query()" [id]="parseToId('btnQuery')"></button>
      </div>
    </div>
  </p-panel>
</form>

<p-panel [showHeader]="false">
  <!-- Detail Menu Bar -->
  <p-menubar *ngIf="detailMenubarVisible()" [model]="detailMenu" class="bpaas-detail-menubar" [id]="parseToId('detailMenu')">
  </p-menubar>

  <!-- Table Tab Menu -->
  <p-tabMenu #detailTabMenuComponent [model]="detailTabs" styleClass="bpaas-table-tabmenu"
    (activeItemChange)="onDetailTabActiveItemChange($event)">
  </p-tabMenu>

  <!-- Table Component -->
  <p-table #tableComponent [value]="detailDatas"
    styleClass="p-datatable-gridlines p-datatable-sm p-datatable-striped"
    [selectionMode]="tableSelectionMode" [(selection)]="rowSelectedDatas"
    [dataKey]="rowDataKeyName" [selectionPageOnly]="true"
    [paginator]="true" [rows]="5" [showCurrentPageReport]="true"
    currentPageReportTemplate="{{ 'table.paginator' | translate: {'first': '{first}', 'last': '{last}', 'totalRecords': '{totalRecords}' } }}"
    [rowsPerPageOptions]="[2, 5, 10]" scrollHeight="75vh" [scrollable]="true"
    (onRowSelect)="onRowSelect()" (onRowUnselect)="onRowUnselect()" (onHeaderCheckboxToggle)="onHeaderCheckboxToggle()"
    stateStorage="session" [stateKey]="tableStateStorageName"
    [resizableColumns]="true" columnResizeMode="expand"
    [columns]="selectedColumns"
    [detailInViewStatus]="detailInViewStatus()"
    (onStateSave)="onDetailTableStateSave($event)"
    (onFilter)="onDetailTableFilter($event)"
    (onSort)="onDetailTableSort($event)"
    editMode="row"
    (onTab)="onTab($event)"
    (inlineSubmitted)="onInlineSubmitted($event)"
    (onPatchEditableRow)="onPatchEditableRow($event)"
    (onSaveEditableRow)="onSaveEditableRow()"
    (onDeleteEditableRow)="onDeleteEditableRow($event)"
    (onCancelEditableRow)="onCancelEditableRow()"
    (focusFirstInvalidField)="focusFirstInvalidField()"
    (onColResize)="onColResize($event)">

    <!-- Table Header -->
    <ng-template pTemplate="header" let-columns>
      <tr id="bpaas-table-header">
        <!-- Table Header Checkbox -->
        <th alignFrozen="left" pFrozenColumn
          style="min-width: 42px !important; max-width: 42px !important; width: 42px !important; text-align: center;">
          <p-tableHeaderCheckbox *ngIf="tableSelectionMode == 'multiple' && !isTableInEdit()"
            [id]="parseToId('tableHeaderCheck')"></p-tableHeaderCheckbox>
        </th>

        <!-- Table Header Columns -->
        <th *ngFor="let column of columns"
          [pSortableColumn]="column.sortable ? column.field : ''"
          [pSortableColumnDisabled]="column.sortable && !isTableInEdit() ? false : true"
          [class.bpaas-cust-width-column]="column.width !== undefined"
          [style]="column.width ? 'width: ' + column.width + 'px; min-width: ' + column.width + 'px; max-width: ' + column.width + 'px' : ''"
          pResizableColumn>
          <label [class]="column.required ? 'bpaas-required' : ''">
            {{ column.header | translate }}
          </label>
          <p-sortIcon *ngIf="column.sortable && !isTableInEdit()" [field]="column.field"></p-sortIcon>
        </th>

        <!-- Table Header Actions Column -->
        <th alignFrozen="right" pFrozenColumn class="bpaas-align-center"
          style="min-width: 110px !important; max-width: 110px !important; width: 110px !important;">
          Actions
        </th>
      </tr>

      <!-- Table Header Filter -->
      <tr *ngIf="tableFilterShow">
        <th alignFrozen="left" pFrozenColumn>
          &nbsp;
        </th>
        <th *ngFor="let column of columns">
          <ng-container *ngIf="column.filter">

            <ng-container [ngSwitch]="column.filter.type">
              <p-columnFilter [type]="column.filter.type"
                [field]="column.filter.field ? column.filter.field : column.field"
                [matchMode]="column.filter.matchMode ? column.filter.matchMode : 'contains'"
                styleClass="w-full"
                [showClearButton]="false"
                [showButtons]="false"
                [showMenu]="column.filter.type == 'dropdown' ? false : true">

                <!-- Table Header Dropdown Filter -->
                <ng-template *ngIf="column.filter.type == 'dropdown'"
                  pTemplate="filter" let-value let-filter="filterCallback">
                  <p-dropdown [ngModel]="value" [options]="column.filter.options"
                    [optionLabel]="column.filter.translateOptionFieldName ? ('label' | translateFieldName: 'label') : 'label'"
                    optionValue="value"
                    placeholder="Any"
                    (onChange)="filter($event.value)" [showClear]="true" appendTo="body">
                  </p-dropdown>
                </ng-template>

                <!-- Table Header Date Filter -->
                <ng-template *ngIf="column.filter.type == 'date'"
                  pTemplate="filter" let-value let-filter="filterCallback">
                  <p-calendar #calendar [ngModel]="value"
                    (onSelect)="filter(calendar.value)"
                    (keydown.enter)="filter(calendar.value)"
                    dateFormat="yy/mm/dd" dataType="string"
                    appendTo="body">
                  </p-calendar>
                </ng-template>
              </p-columnFilter>
            </ng-container>

          </ng-container>
        </th>
        <th alignFrozen="right" pFrozenColumn>
          &nbsp;
        </th>
      </tr>
    </ng-template>

    <!-- Table Body -->
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-editing="editing" let-columns="columns">
      <tr [id]="parseToId('rowData-' + rowIndex)" [pEditableRow]="rowData"
        [formGroup]="inlineFormGroup" pBPaaSFocusTrap>
        <!-- Table Body Checkbox or RadioButton Column -->
        <td alignFrozen="left" pFrozenColumn
          style="min-width: 42px !important; max-width: 42px !important; width: 42px !important; text-align: center;">
          <p-tableRadioButton *ngIf="!isTableInEdit() && tableSelectionMode == 'single'" [value]="rowData" [id]="parseToId('rowData-' + rowIndex + '-radio')"></p-tableRadioButton>
          <p-tableCheckbox *ngIf="!isTableInEdit() && tableSelectionMode == 'multiple'" [value]="rowData" [id]="parseToId('rowData-' + rowIndex + '-check')"></p-tableCheckbox>
        </td>

        <ng-template #templateInput>
          <input type="text" pInputText
            formControlName="input" [id]="parseToId('input-' + rowIndex)" class="w-full"
            [ngClass]="{'bpaas-inline-required': true, 'ng-dirty': inlineFormControlInvalid('input')}">
          <div *ngIf="inlineFormControlInvalid('input')">
            <small class="p-error"
              *ngIf="inlineFormControl('input').errors?.['required']">
              {{ 'message.validation.required' | translate }}
            </small>
          </div>
        </ng-template>

        <ng-template #templateCalendar>
          <p-calendar
            [showIcon]="true" appendTo="body" styleClass="w-full"
            [showOnFocus]="false"
            panelStyleClass="bpaas-calendar"
            formControlName="calendar" dateFormat="yy/mm/dd" dataType="string"
            placeholder="yyyy/mm/dd" [inputId]="parseToId('calendar-' + rowIndex)"
            [ngClass]="{'bpaas-inline-required': true, 'ng-dirty': inlineFormControlInvalid('calendar')}">
          </p-calendar>
          <div *ngIf="inlineFormControlInvalid('calendar')">
            <small class="p-error"
              *ngIf="inlineFormControl('calendar').errors?.['required']">
              {{ 'message.validation.required' | translate }}
            </small>
          </div>
        </ng-template>

        <ng-template #templateDropdown>
          <p-dropdown *ngIf="langChangeVisible"
            [options]="exampleOptions"
            placeholder="{{ 'option.please-select' | translate }}" [showClear]="false"
            appendTo="body" styleClass="w-full"
            formControlName="dropdown" [inputId]="parseToId('dropdown-' + rowIndex)"
            [ngClass]="{'bpaas-inline-required': true, 'ng-dirty': inlineFormControlInvalid('dropdown')}">
          </p-dropdown>
          <div *ngIf="inlineFormControlInvalid('dropdown')">
            <small class="p-error"
              *ngIf="inlineFormControl('dropdown').errors?.['required']">
              {{ 'message.validation.required' | translate }}
            </small>
          </div>
        </ng-template>

        <ng-template #templateAutoCompleteCode>
          <p-autoComplete *ngIf="langChangeVisible"
            [suggestions]="exampleDataSuggestions"
            [forceSelection]="true"
            [minLength]="2" [delay]="300" [showClear]="false"
            [showEmptyMessage]="true" emptyMessage="{{ 'table.no-records-found' | translate }}"
            (completeMethod)="searchExampleDataSuggestions($event)"
            (onClear)="autoCompleteCleared('autoCompleteCode', inlineFormGroup)"
            (onFocus)="autoCompleteFocus($event)"
            (onBlur)="autoCompleteBlur($event)"
            (onKeyUp)="autoCompleteKeyUp($event)"
            (onSelect)="autoCompleteCompleted('autoCompleteCode', inlineFormGroup)"
            dataKey="exampleDataCode"
            appendTo="body" styleClass="w-full" inputStyleClass="w-full"
            formControlName="autoCompleteCode" [inputId]="parseToId('autoCompleteCode-' + rowIndex)"
            field="{{ 'exampleDataName' | translateFieldName: 'exampleDataName' }}">
            <ng-template let-exampleData pTemplate="item">
              {{ exampleData.exampleDataCode }} {{ exampleData.exampleDataName | translateDataValue: exampleData : 'exampleDataName' }}
            </ng-template>
          </p-autoComplete>
        </ng-template>

        <ng-template #templateInputNumber>
          <p-inputNumber formControlName="inputNumber"
            class="w-full" styleClass="w-full" inputStyleClass="w-full"
            [step]="0"
            [inputId]="parseToId('inputNumber')"></p-inputNumber>
        </ng-template>

        <ng-template #templateDynamicDropdown>
          <p-dropdown *ngIf="langChangeVisible"
            [options]="dynamicOptions"
            optionLabel="{{ 'label' | translateFieldName: 'label' }}"
            optionValue="value"
            placeholder="{{ 'option.please-select' | translate }}" [showClear]="true"
            appendTo="body" styleClass="w-full"
            formControlName="dynamicDropdown" [inputId]="parseToId('dynamicDropdown-' + rowIndex)">
          </p-dropdown>
        </ng-template>

        <ng-template #templateAutoCompleteDropdownCode>
          <p-autoComplete *ngIf="langChangeVisible"
            [suggestions]="allExampleDataSuggestions"
            [forceSelection]="true"
            [minLength]="2" [delay]="300" [showClear]="false"
            [showEmptyMessage]="true" emptyMessage="{{ 'table.no-records-found' | translate }}"
            (completeMethod)="searchAllExampleDataSuggestions($event)"
            (onClear)="autoCompleteCleared('autoCompleteDropdownCode', inlineFormGroup)"
            (onFocus)="autoCompleteFocus($event)"
            (onBlur)="autoCompleteBlur($event)"
            (onKeyUp)="autoCompleteKeyUp($event)"
            (onSelect)="autoCompleteCompleted('autoCompleteDropdownCode', inlineFormGroup)"
            [dropdown]="true" dropdownMode="blank"
            [completeOnFocus]="false"
            appendTo="body" styleClass="w-full" inputStyleClass="w-full"
            formControlName="autoCompleteDropdownCode" [inputId]="parseToId('autoCompleteDropdownCode-' + rowIndex)"
            field="{{ 'exampleDataName' | translateFieldName: 'exampleDataName' }}">
            <ng-template let-exampleData pTemplate="item">
              {{ exampleData.exampleDataCode }} {{ exampleData.exampleDataName | translateDataValue: exampleData : 'exampleDataName' }}
            </ng-template>
          </p-autoComplete>
        </ng-template>

        <ng-template #templateCustValidation>
          <textarea pInputTextarea class="w-full"
            rows="5" [autoResize]="true"
            formControlName="detailCustValidation"
            [id]="parseToId('detailCustValidation-' + rowIndex)"
            [ngClass]="{'ng-dirty': inlineFormControlInvalid('detailCustValidation')}">
          </textarea>
          <div *ngIf="inlineFormControlInvalid('custValidation')">
            <small class="p-error"
              *ngIf="inlineFormControl('custValidation').errors?.['duplicate']">
              {{ 'message.validation.duplicate' | translate }}
            </small>
          </div>
        </ng-template>

        <td *ngFor="let column of columns"
          [class.bpaas-align-right]="column.numberField"
          [class.bpaas-new-line]="column.overflowBreak"
          [class.bpaas-cust-width-column]="column.width !== undefined"
          [style]="column.width ? 'width: ' + column.width + 'px; min-width: ' + column.width + 'px; max-width: ' + column.width + 'px' : ''"
          [id]="parseToId('rowData-' + rowIndex + '-' + column.field)"
          pBpaasEditableColumn>

          <p-cellEditor>
            <!-- Table Body Inline Edit -->
            <ng-template pTemplate="input">
              <ng-container [ngSwitch]="column.field">
                <ng-container *ngSwitchCase="'input'">
                  <ng-container *ngTemplateOutlet="templateInput"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'calendar'">
                  <ng-container *ngTemplateOutlet="templateCalendar"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'dropdown'">
                  <ng-container *ngTemplateOutlet="templateDropdown"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'autoCompleteName'">
                  <ng-container *ngTemplateOutlet="templateAutoCompleteCode"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'inputNumber'">
                  <ng-container *ngTemplateOutlet="templateInputNumber"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'dynamicDropdown'">
                  <ng-container *ngTemplateOutlet="templateDynamicDropdown"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'autoCompleteDropdownName'">
                  <ng-container *ngTemplateOutlet="templateAutoCompleteDropdownCode"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'custValidation'">
                  <ng-container *ngTemplateOutlet="templateCustValidation"></ng-container>
                </ng-container>
              </ng-container>
            </ng-template>

            <!-- Table Body Data Display -->
            <ng-template pTemplate="output">
              <ng-container *ngIf="column.translateDataValueField && langChangeVisible">
                {{ rowData[column.field] | translateDataValue: rowData : column.translateDataValueField }}
              </ng-container>
              <ng-container *ngIf="column.translateArrayValue && langChangeVisible">
                {{ rowData[column.field] | translateArrayValue: column.translateArrayValue.datas : column.translateArrayValue.valueField : column.translateArrayValue.displayField }}
              </ng-container>
              <ng-container *ngIf="column.numberField">
                {{ (rowData[column.field] ?? (column.numberFieldDefaultZero ? 0 : '')) | dynamicDecimal }}
              </ng-container>
              <ng-container *ngIf="column.dateField">
                {{ rowData[column.field] | date: (column.dateFormat ? column.dateFormat : 'yyyy/MM/dd') : 'GMT+8' }}
              </ng-container>
              <ng-container *ngIf="column.customField">
                <!-- 如果有需要條件判斷處理值的，自己寫在這段裡面 -->
              </ng-container>
              <ng-container *ngIf="!column.customField && !column.translateDataValueField
                && !column.translateArrayValue && !column.numberField && !column.dateField">
                {{ rowData[column.field] }}
              </ng-container>
            </ng-template>
          </p-cellEditor>
        </td>

        <!-- Table Body Inline Edit Actions -->
        <td alignFrozen="right" pFrozenColumn  class="bpaas-align-center"
          style="min-width: 110px !important; max-width: 110px !important; width: 110px !important;">
          <button *ngIf="editing" pButton type="button" pBpaasSaveEditableRow [id]="parseToId('btnSaveEditableRow')"
            icon="pi pi-check" class="p-button-rounded p-button-text p-button-success mr-1" tabindex="-1"
            title="{{ 'button.complete' | translate }}"></button>
          <button *ngIf="editing" pButton type="button" pBpaasCancelEditableRow [id]="parseToId('btnCancelEditableRow')"
            icon="pi pi-times" class="p-button-rounded p-button-text p-button-info mr-1" tabindex="-1"
            title="{{ 'button.cancel' | translate }}"></button>
          <button *ngIf="editing" pButton type="button" pBpaasDeleteEditableRow [id]="parseToId('btnDeleteEditableRow')"
            icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger" tabindex="-1"
            title="{{ 'button.delete' | translate }}"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [colSpan]="tableColumns.length + 2">
          {{ 'table.no-records-found' | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-panel>
